import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { Badge, Button } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import * as AiIcons from "react-icons/ai";
import { MdEventAvailable } from "react-icons/md";
import UpdateAreaN2 from './UpdateAreaN2';
import { FaEdit } from "react-icons/fa";
import { MdAccountTree } from "react-icons/md";
import { BsPersonLinesFill } from "react-icons/bs";
import UpdatePosicion from './UpdatePosicion';
import { dtFormatter } from './AuxiliaryFunctions';
import UpdateCompetencia from './UpdateCompetencia';
import OrganigramaAreaDataService from './services/organigramaarea.service';
import AsignarOrganigrama from './AsignarOrganigrama';
import { useSelector } from "react-redux";
import DisponibilidadDataService from './services/disponibilidad.service';
import {PiWarningDuotone} from 'react-icons/pi';
import { FcCancel } from "react-icons/fc";
import { FaUsersViewfinder } from "react-icons/fa6";
import ListaCompleta from './ListaCompleta';

const TableHeader = (props) => {
  const { user: currentUser } = useSelector((state) => state.auth);	
  return (

    <thead>
      <tr>
        <th className='d-none d-sm-table-cell' style={{width:'8%'}}>ID Competencia</th>
        <th style={{width:'8%'}}>Estatus</th>
        <th style={{width:'10%'}}>Nombre Competencia</th>
        <th className='d-none d-sm-table-cell' style={{width:'25%'}}>Descripción Competencia</th>
        <th style={{width:'10%'}}>Fecha</th>
        {/**
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Fecha de fin</th>
        */}
        {(currentUser.roles.includes(4) || currentUser.roles.includes(3)) &&
        <>
        <th style={{width:'5%'}}>{props.mode==0?'Editar ':''}</th>
        <th style={{width:'25%'}}>{'Organigrama (Asignar o Editar)'}</th>
        <th style={{width:'10%'}}>{'Listado de jueces'}</th>        
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>{'Lista Completa'}</th>   
        </>
        }
        {(!currentUser.roles.includes(4) && !currentUser.roles.includes(3)) &&
        <>
        <th style={{width:'3%'}}>{''}</th>        
        </>
        }

      </tr>
    </thead>
  )
}

const TableBody = (props) => {  
  const { user: currentUser } = useSelector((state) => state.auth);	

  if (props.listOfCompetencias) {    
    const rows = props.listOfCompetencias.map((row, index) => { 
      const ConfirmEle = (props) => {
        if ((row.requserIdconfirmed) && (row.confirmacion_activa !== 0)) {
          return (
            <div style={{color:'green'}}>
              <AiIcons.AiFillCheckCircle size={25}/>
            </div>
          )
        }
        else {
          if (props.row.estatus_competencia !== 2) {
            return (
              <div style={{color:'green'}}>
                <FcCancel size={25}/>
              </div>
            )
          }
          else {
            if ((row.confirmacion_activa === 0) && (row.requserIdconfirmed)) {
              return (
                <>
                <Link className='primary' 
                  to={'/confirm-availability'}
                  state={{
                    competencia: row              
                  }}
                >
                  <PiWarningDuotone size={25} color='red'/>
                </Link>              
                </>
              )
            }
            else if (!row.requserIdconfirmed) {
              return (
                <Link className='primary' 
                  to={'/confirm-availability'}
                  state={{
                    competencia: row              
                  }}
                >
                  <MdEventAvailable size={25} />
                </Link>                
              )
            }
          }
        };
      };
      
      return (      
        <>
        <tr key={index}>        
          <td className='d-none d-sm-table-cell'>
            {"COM-" + row.id}
          </td>
          <td>
            {
              row.estatus_competencia===1?<Badge bg="secondary">Preliminar</Badge>:
              row.estatus_competencia===2?<Badge bg="success">Abierta</Badge>:
              row.estatus_competencia===3?<Badge bg="warning">En curso</Badge>:
              row.estatus_competencia===4?<Badge bg="danger">Cerrada</Badge>:null
            }
          </td>
          <td>  
            {row.nombrecompetencia}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.descripcioncompetencia}
          </td>          
          <td>  
            {dtFormatter(new Date(row.fechainicio),1)}
          </td>            
          {/**
          <td className='d-none d-sm-table-cell'>  
            {dtFormatter(new Date(row.fechafin),1)}
          </td>
          */} 

          {(currentUser.roles.includes(4) || currentUser.roles.includes(3)) &&
          <>
          <td align='center'>  
            {(props.mode==0) && // editar
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderEditTooltip}>        
                <UpdateCompetencia 
                  editrow = {row}
                  id = {row.id}
                  nombrecompetencia = {row.nombrecompetencia}
                  descripcioncompetencia = {row.descripcioncompetencia}
                  fechainicio = {row.fechainicio}
                  fechafin = {row.fechafin}
                  mode={0}/>    
              </OverlayTrigger>              
            }
            {(props.mode==1) && // seleccionar
              <Button onClick={() => {
                //console.log(row);
                props.onSelected(row.id,row.nombrecompetencia,row.descripcioncompetencia);
                props.handleClose();
              }} variant='link' value={row.id}>Seleccionar</Button>
            } 
          </td>  
          <td>
            <AsignarOrganigrama 
              id={row.id} competencia={row}
            />
          </td> 
          <td>            
            {/*organigrama/competencia/usuario */}
            <Button variant="secondary"><Link to = {`/listadejuecescompetencia/${row.organigramaId}/${row.id}/${"all"}`}><FaUsersViewfinder size={15} color='white'/></Link></Button>
          </td>  
          </>
          }     
        {(!currentUser.roles.includes(4) && !currentUser.roles.includes(3)) &&
        <>
        <td style={{textAlign:'center'}}>
          <ConfirmEle row={row}/>
        </td>   
        </>
        }  
        {(currentUser.roles.includes(4) || currentUser.roles.includes(3)) &&     
        <td className='d-none d-sm-table-cell' >
          <Button variant="secondary"><Link to = {`/listacompletadeusuarioscompetencia/${row.id}`}><BsPersonLinesFill size={15} color='white'/></Link></Button>
        </td>                                 
        }
        </tr>
        </>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the user.
  </Tooltip>
);

const CompetenciasList = (props) => {        
  //console.log(props);
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode}/>
            <TableBody row={props.row} mode={props.mode} handleClose={props.handleClose} onSelected={props.onSelected} arean2id={props.arean2id} listOfCompetencias={props.listOfCompetencias} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
};

export default CompetenciasList;